<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addOfferModal"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة عرض جديد
            </button>

            <!-- Add New offer -->
            <div
              class="modal fade"
              id="addOfferModal"
              tabindex="-1"
              aria-labelledby="addOfferModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة عرض</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form @submit.prevent="addNewOffer($event)">
                      <div class="row">
                        <div class="col-lg-6 col-12">
                          <!-- offer title -->
                          <div class="col-12">
                            <div class="form-group">
                              <label for="offerTitle">العنوان</label>
                              <input
                                type="text"
                                id="offerTitle"
                                class="form-control"
                                placeholder="العنوان"
                                v-model="offer.title"
                                required
                              />
                            </div>
                          </div>
                          <!-- offer description -->
                          <div class="col-12">
                            <div class="form-group">
                              <label for="offerDescription">الوصف</label>
                              <textarea
                                id="offerDescription"
                                class="form-control"
                                placeholder="الوصف"
                                v-model="offer.description"
                                cols="30"
                                rows="5"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-12">
                          <!-- Offer Image -->
                          <div class="col-12">
                            <div class="form-group">
                              <label>صورة العرض</label>
                              <UploadImages
                                class="form-control"
                                @changed="handleImages"
                                :max="1"
                                maxError="يمكنك رفع صورة واحدة لكل درس"
                                fileError="لا يمكن رفع ملفات غير الصور"
                              />
                            </div>
                          </div>
                        </div>

                        <!-- offer type -->
                        <div class="col-12">
                          <div class="form-group">
                            <label>نوع العرض</label>
                            <select
                              class="form-control form-select"
                              aria-label="Default select"
                              v-model="offer.offerType"
                            >
                              <option selected disabled :value="0">
                                اختيار نوع العرض
                              </option>
                              <option :value="1">درس</option>
                            </select>
                          </div>
                        </div>

                        <!-- if add offer on Lesson -->
                        <Transition name="scale" mode="out-in">
                          <div class="col-12" v-if="offer.offerType === 1">
                            <div class="form-group">
                              <label>الدروس</label>
                              <v-select
                                v-if="lessons.length > 0"
                                class="form-select form-control mt-2"
                                v-model="offer.fullLessonInfo"
                                multiple
                                :options="lessons"
                                label="title"
                              />
                              <div v-else class="text-center">
                                <span>لا يوجد دروس حتى الان</span>
                              </div>
                            </div>
                          </div>
                        </Transition>

                        <!-- offer regular price -->
                        <div class="col-lg-6 col-12">
                          <div class="form-group">
                            <label for="offerRegPrice">السعر الاساسى</label>
                            <input
                              type="number"
                              id="offerRegPrice"
                              class="form-control"
                              placeholder="السعر الاساسى"
                              :value="offer.regular_price"
                              disabled
                            />
                          </div>
                        </div>
                        <!-- offer sale price -->
                        <div class="col-lg-6 col-12">
                          <div class="form-group">
                            <label for="offerRegPrice">السعر بعد الخصم</label>
                            <input
                              type="number"
                              id="offerRegPrice"
                              class="form-control"
                              placeholder="السعر بعد الخصم"
                              v-model="offer.sale_price"
                              :max="offer.regular_price - 1"
                              required
                            />
                          </div>
                        </div>
                        <!-- Offer Start -->
                        <div class="col-lg-6 col-12">
                          <div class="form-group">
                            <label for="offerStartDate">بداية العرض</label>
                            <input
                              type="datetime-local"
                              class="form-control mt-2"
                              id="offerStartDate"
                              placeholder="بداية العرض"
                              :min="today"
                              v-model="offer.start_date"
                              required
                            />
                          </div>
                        </div>
                        <!-- Offer End -->
                        <div class="col-lg-6 col-12">
                          <div class="form-group">
                            <label for="offerEndDate">نهاية العرض</label>
                            <input
                              type="datetime-local"
                              class="form-control mt-2"
                              id="offerEndDate"
                              placeholder="نهاية العرض"
                              v-model="offer.end_date"
                              :min="today"
                              required
                            />
                          </div>
                        </div>
                        <!-- Submit -->
                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button type="submit" class="btn w-100 add">
                              أضافة
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add New offer -->

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table v-show="this.offers.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th class="fit" scope="col">الرقم</th>
                  <th scope="col">العنوان</th>
                  <th scope="col">الوصف</th>
                  <th scope="col">عنوان الدرس</th>
                  <th class="fit" scope="col">السعر</th>
                  <th class="fit" scope="col">بعد الخصم</th>
                  <!-- <th scope="col">البداية</th> -->
                  <!-- <th scope="col">النهاية</th> -->
                  <th style="width: 18%" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(offer, index) in this.offers" :key="index">
                  <th>{{ index + 1 }}</th>
                  <td>{{ offer.title }}</td>
                  <td>{{ offer.description }}</td>
                  <td>
                    <ul class="pe-0">
                      <li
                        v-for="(lesson, index) in offer.fullLessonInfo"
                        :key="index"
                      >
                        - {{ lesson.title }}
                      </li>
                    </ul>
                  </td>
                  <td>{{ offer.regular_price }}</td>
                  <td>{{ offer.sale_price }}</td>
                  <!-- <td>{{ offer.start_date }}</td> -->
                  <!-- <td>{{ offer.end_date }}</td> -->
                  <td>
                    <button
                      class="btn edit"
                      data-bs-toggle="modal"
                      data-bs-target="#editOfferModal"
                      @click="this.getOfferById(offer.offer_id)"
                    >
                      <i class="fas fa-edit ms-1"></i>
                      تعديل
                    </button>
                    <!-- Edit Modal -->

                    <!-- Add New offer -->
                    <div
                      class="modal fade"
                      id="editOfferModal"
                      tabindex="-1"
                      aria-labelledby="editOfferModalLabel"
                      aria-hidden="true"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                    >
                      <div class="modal-dialog modal-lg modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">تعديل العرض</h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              @click="clearData"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <form @submit.prevent="editSelectedOffer($event)">
                              <div class="row">
                                <div class="col-lg-6 col-12">
                                  <!-- offer title -->
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for="offerTitle">العنوان</label>
                                      <input
                                        type="text"
                                        id="offerTitle"
                                        class="form-control"
                                        placeholder="العنوان"
                                        v-model="OfferSelected.title"
                                        required
                                      />
                                    </div>
                                  </div>
                                  <!-- offer description -->
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for="offerDescription"
                                        >الوصف</label
                                      >
                                      <textarea
                                        id="offerDescription"
                                        class="form-control"
                                        placeholder="الوصف"
                                        v-model="OfferSelected.description"
                                        cols="30"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-12">
                                  <!-- Offer Image -->
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label>صورة العرض</label>
                                      <UploadImages
                                        class="form-control"
                                        @changed="handleImages"
                                        :max="1"
                                        maxError="يمكنك رفع صورة واحدة لكل درس"
                                        fileError="لا يمكن رفع ملفات غير الصور"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <!-- offer type -->
                                <div class="col-12">
                                  <div class="form-group">
                                    <label>نوع العرض</label>
                                    <select
                                      class="form-control form-select"
                                      aria-label="Default select"
                                      v-model="offer.offerType"
                                    >
                                      <option selected disabled :value="0">
                                        اختيار نوع العرض
                                      </option>
                                      <option :value="1">درس</option>
                                    </select>
                                  </div>
                                </div>

                                <!-- if add offer on Lesson -->
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="col-12"
                                    v-if="offer.offerType === 1"
                                  >
                                    <div class="form-group">
                                      <label>الدروس</label>
                                      <v-select
                                        v-if="lessons.length > 0"
                                        class="form-select form-control mt-2"
                                        v-model="OfferSelected.fullLessonInfo"
                                        multiple
                                        :options="lessons"
                                        label="title"
                                      />
                                      <div v-else class="text-center">
                                        <span>لا يوجد دروس حتى الان</span>
                                      </div>
                                    </div>
                                  </div>
                                </Transition>

                                <!-- offer regular price -->
                                <div class="col-lg-6 col-12">
                                  <div class="form-group">
                                    <label for="offerRegPrice"
                                      >السعر الاساسى</label
                                    >
                                    <input
                                      type="number"
                                      id="offerRegPrice"
                                      class="form-control"
                                      placeholder="السعر الاساسى"
                                      :value="OfferSelected.regular_price"
                                      disabled
                                    />
                                  </div>
                                </div>
                                <!-- offer sale price -->
                                <div class="col-lg-6 col-12">
                                  <div class="form-group">
                                    <label for="offerRegPrice"
                                      >السعر بعد الخصم</label
                                    >
                                    <input
                                      type="number"
                                      id="offerRegPrice"
                                      class="form-control"
                                      placeholder="السعر بعد الخصم"
                                      v-model="OfferSelected.sale_price"
                                      :max="OfferSelected.regular_price - 1"
                                      required
                                    />
                                  </div>
                                </div>
                                <!-- Offer Start -->
                                <div class="col-lg-6 col-12">
                                  <div class="form-group">
                                    <label for="offerStartDate"
                                      >بداية العرض</label
                                    >
                                    <input
                                      type="datetime-local"
                                      class="form-control mt-2"
                                      id="offerStartDate"
                                      placeholder="بداية العرض"
                                      :min="today"
                                      v-model="OfferSelected.start_date"
                                      required
                                    />
                                  </div>
                                </div>
                                <!-- Offer End -->
                                <div class="col-lg-6 col-12">
                                  <div class="form-group">
                                    <label for="offerEndDate"
                                      >نهاية العرض</label
                                    >
                                    <input
                                      type="datetime-local"
                                      class="form-control mt-2"
                                      id="offerEndDate"
                                      placeholder="نهاية العرض"
                                      v-model="OfferSelected.end_date"
                                      :min="today"
                                      required
                                    />
                                  </div>
                                </div>
                                <!-- Submit -->
                                <div class="col-12">
                                  <div class="form-group text-start mt-4">
                                    <button type="submit" class="btn w-100 add">
                                      تعديل
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Edit Modal -->
                    <button
                      class="btn me-2 delete"
                      @click="this.deleteSelectedOffer(offer)"
                    >
                      <i class="fas fa-trash-alt ms-1"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.offers) || this.offers.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد عروض حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UploadImages from "vue-upload-drop-images";
// Swal
import Swal from "sweetalert2";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();
// Delete from firebase Storage
import { deleteFileFromUrl } from "@/firebase/firebase_storage";

export default {
  data() {
    return {
      // today
      today: new Date().toISOString().substr(0, 10),
      // handle Upload
      file: null,
      // Page Name
      currentView: "العروض",
      // Loading
      isloading: true,
      isfirstLoad: true,
      // Lessons
      lessons: [],

      OfferSelected: {
        fullLessonInfo: [],
      },
      // Data
      offers: [],
      offer: {
        title: "",
        description: "",
        thumbnail_url: "",
        contents: [],
        fullLessonInfo: [],
        regular_price: 0,
        sale_price: 0,
        start_date: "",
        end_date: "",
        offerType: 0,
      },
      searchValue: "",
    };
  },
  components: {
    UploadImages,
  },
  methods: {
    ...mapActions("offersModule", [
      "fetchOffers",
      "addOffer",
      "getOfferById",
      "updateOffer",
      "deleteOffer",
    ]),
    ...mapActions("lessonsModule", ["fetchLessons"]),
    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.offers.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.offers.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------

    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.offers = this.getOffers.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------

    //----Default Functions
    // Add New Offer
    addNewOffer(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      this.onSelectLessons();
      if (this.file !== null) {
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,

          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع الصورة العرض الان",
            file: this.file,
            collection: "IMAGEs",
            onFinished: (url) => {
              this.offer.thumbnail_url = url ?? "";
              toast.dismiss(toastId);
              this.addOffer(this.offer);
              closeButton.click();
              this.clearAndShowSuccess("تم إضافة العرض بنجاح");
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.addOffer(this.offer);
        closeButton.click();
        this.clearAndShowSuccess("تم إضافة العرض بنجاح");
      }
    },

    // Edit offer
    editSelectedOffer(event) {
      this.onSelectLessons();
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      if (this.file !== null) {
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,

          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع الصورة العرض الان",
            file: this.file,
            collection: "IMAGEs",
            onFinished: (url) => {
              this.OfferSelected.thumbnail_url = url ?? "";
              toast.dismiss(toastId);
              this.updateOffer(this.OfferSelected);
              closeButton.click();
              this.clearAndShowSuccess("تم تعديل العرض بنجاح");
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.updateOffer(this.OfferSelected);
        closeButton.click();
        this.clearAndShowSuccess("تم تعديل العرض بنجاح");
      }
    },

    // Delete offer
    deleteSelectedOffer(offer) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا العرض؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الصورة التوضيحية بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          deleteFileFromUrl(offer.thumbnail_url);
          this.deleteOffer(offer.offer_id);
        }
      });
    },

    // Get all offers
    async getAllOffers() {
      this.offers = await this.fetchOffers();
    },

    // Get all Lessons
    async getAllLessons() {
      this.lessons = await this.fetchLessons();
    },

    handleImages(files) {
      this.file = files[0];
    },

    onSelectLessons() {
      let contentsIDs = [];

      if (this.offer.fullLessonInfo.length > 0) {
        this.offer.fullLessonInfo.forEach((lesson) =>
          contentsIDs.push(lesson.lesson_id)
        );
        this.offer.contents = contentsIDs;
      }

      if (this.OfferSelected.fullLessonInfo.length > 0) {
        this.OfferSelected.fullLessonInfo.forEach((lesson) =>
          contentsIDs.push(lesson.lesson_id)
        );
        this.OfferSelected.contents = contentsIDs;
      }
    },

    getTotalPrice(offer) {
      let totalPrice = [];
      offer.fullLessonInfo.forEach((lesson) => totalPrice.push(lesson.price));
      this.offer.regular_price = totalPrice.reduce((x, y) => x + y, 0);
    },

    getEditTotalPrice(offer) {
      let totalPrice = [];
      offer.fullLessonInfo.forEach((lesson) => totalPrice.push(lesson.price));
      this.OfferSelected.regular_price = totalPrice.reduce((x, y) => x + y, 0);
    },

    clearAndShowSuccess(message) {
      this.seccussAdd(message);
      this.clearData();
    },

    seccussAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Clear Data
    clearData() {
      let clearButton = document.querySelector(".clearButton");
      clearButton.click();
      this.file = null;
      this.offer = {
        title: "",
        description: "",
        thumbnail_url: "",
        contents: [],
        fullLessonInfo: [],
        regular_price: 0,
        sale_price: 0,
        start_date: "",
        end_date: "",
        offerType: 0,
      };
    },
  },
  async created() {
    if (this.isFirstLoad) await this.getAllOffers();
    this.getAllLessons();
    this.offers = this.getOffers;
  },
  computed: {
    ...mapGetters("offersModule", [
      "getOffers",
      "getUpdateOffer",
      "isLoading",
      "isFirstLoad",
    ]),
    ...mapGetters("lessonsModule", ["getLessons"]),
  },
  mounted() {
    this.offers = this.getOffers;
    this.lessons = this.getLessons;
    this.isloading = this.isLoading;
    this.isfirstLoad = this.isFirstLoad;
  },
  watch: {
    getOffers() {
      this.offers = this.getOffers;
    },
    getUpdateOffer() {
      this.OfferSelected = this.getUpdateOffer;
    },
    getLessons() {
      this.lessons = this.getLessons;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.isfirstLoad = this.isFirstLoad;
    },
    offer: {
      deep: true,
      handler: function (newValue) {
        this.getTotalPrice(newValue);
      },
    },
    OfferSelected: {
      deep: true,
      handler: function (newValue) {
        this.getEditTotalPrice(newValue);
      },
    },
  },
};
</script>

<style></style>
